import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class SiteConfigService extends ServiceBase {
    /**
     * Fetch site configuration including maintenance state
     * @returns {Promise} response with SiteConfigDto
     */
    getSiteConfig = () => {
        try {
            const url = `${baseUrl}/${service}/site/config`;
            return agent.get(url, null, false);
        } catch (error) {
            return null;
        }
    };

    /**
     * Save site configuration — admin only
     * @param {object} dto - SiteConfigDto
     * @param {string} jwt - Clerk JWT token
     * @returns {Promise}
     */
    saveSiteConfig = (dto, jwt) => {
        const url = `${baseUrl}/${service}/site/config`;

        const config = {
            headers: { Authorization: `Bearer ${jwt}` },
        };

        return agent.post(url, dto, config);
    };
}

const configService = new SiteConfigService();
export default configService;
